<template>
  <!-- page-wrapper Start-->
  <div class="page-wrapper compact-wrapper" id="pageWrapper">
    <div class="page-body-wrapper">
      <div class="page-body">
        <!-- Breadcrumb & Title -->
        <div class="container-fluid">
          <div class="page-title">
            <div class="row">
              <div class="col-12 col-sm-6">
                <h3>Service List</h3>
              </div>
              <div class="col-12 col-sm-6">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item">
                    <a class="home-item" href="/"><i data-feather="home"></i></a>
                  </li>
                  <li class="breadcrumb-item">Dashboard</li>
                  <li class="breadcrumb-item">Customer List</li>
                  <li class="breadcrumb-item active">Services</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <!-- Breadcrumb & Title -->

        <!-- Container-fluid starts-->
        <div class="container-fluid list-products">
          <div class="row">
            <!-- Data table -->
            <div class="col-sm-12 col-lg-12" v-if="this.customerServiceList.length > 0">
              <div class="card">
                <div class="card-header pb-0">
                  <h5>List</h5>
                  <span>Customer List</span>
                </div>
                <div class="card-body">
                  <div class="table-responsive product-tabl">
                    <table class="display w-100" id="customerListTBL">
                      <thead>
                        <tr align="center">
                          <th>#</th>
                          <th>Title</th>
                          <th>Price</th>
                          <th>Active Status</th>
                          <!-- <th>Status</th> -->
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr align="center" v-for="(item, index) in customerServiceList" :key="index">
                          <td>{{ index + 1 }}</td>
                          <td>{{ item.serviceTypeTitle }}</td>
                          <td>{{ item.price }}</td>
                          <td>
                            <span class="badge badge-success" v-if="item.status === 1">Enable</span>
                            <span class="badge badge-warning" v-if="item.status === 2">Disabled</span>
                            <span class="badge badge-danger" v-if="item.status === 0">Deleted</span>
                          </td>

                          <td>

                            <button class="btn btn-primary btn-xs" type="button" data-bs-toggle="modal"
                              data-bs-target="#exampleModal1" @click.prevent="updatePrice(item)">
                              <span class="title"> Update Price</span>
                            </button>

                          </td>
                        </tr>
                      </tbody>
                    </table>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Container-fluid starts-->
        <!-- Modal -->
        <div class="modal fade" id="exampleModal1" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel1"
          aria-hidden="true" v-show="this.selectedItem">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel1">Update Price</h5>
                <button class="btn-close" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body">
                <form class="form-bookmark">
                  <div class="row g-2">
                    <div class="mb-3 col-md-12">
                      <input class="form-control" type="text" required="" placeholder="Enter price" autocomplete="off"
                        v-model="this.selectedItem.price" />
                    </div>
                  </div>
                  <button class="btn btn-secondary" type="button" @click="updatePriceAction">
                    Save
                  </button>
                  <button class="btn btn-primary" type="button" data-bs-dismiss="modal">
                    Cancel
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "jquery/dist/jquery.min.js";
import "bootstrap/dist/css/bootstrap.min.css";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";

import $ from "jquery";
import customerAPI from "../../services/customer.API.js";

export default {
  name: "CustomerServices",
  components: {},
  data() {
    return {
      title: "",
      price: "",
      customerList: [],
      districtList: [],
      isCreate: true,
      update: {
        id: "",
        title: "",
        // active_status: '',
      },
      selectedDistrict: null,
      customerServiceList: [],
      selectedCustomer: "",
      selectedItem: {},
      updatedPrice: "",
      selectedTblData: [],
    };
  },
  methods: {
    updatePrice(item) {
      this.selectedItem = item;
    },
    updatePriceAction() {
      let data = {
        id: this.selectedItem.id,
        price: this.selectedItem.price,
      };
      if (data) {
        customerAPI.updateServicePrice(data).then(
          (response) => {
            if (response?.data?.success === true) {
              this.$moshaToast(response?.data?.message, {
                type: "success",
                position: "top-right",
                showIcon: true,
              });
              this.getServiceList();
              this.selectedItem = {};

              $(".btn-close").click();
              setTimeout(() => {
                location.reload();
              }, 500);

            } else {
              this.$moshaToast(response.data.message, {
                type: "danger",
                position: "top-right",
                showIcon: true,
              });
            }
          },
          (err) => {
            if (err.response.data.success === false) {
              this.$moshaToast(err.response.data.message, {
                type: "danger",
                position: "top-right",
                showIcon: true,
              });
            }
          }
        );
      }
    },
    selectCustomer(e) {
      this.selectedCustomer = e.target.value;
      console.log(this.selectedCustomer);
    },
    // district list
    getList() {
      customerAPI.getList().then(
        (response) => {
          this.customerList = response.data.data;
          // console.log(response.data.data);
        },
        (err) => {
          if (err.response.data.success === false) {
            this.customerList = [];
          }
        }
      );
    },
    getServiceList(id) {
      // let data = {
      //   customer_id: id,
      // };
      // customerAPI.getServiceList(data).then(
      customerAPI.alreadyAssignedServices(id).then(
        (response) => {
          this.customerServiceList = response.data.data;
          // console.log(response.data.data.map(e =>
          //   e.isAssigned === true && e.id
          // ).filter(Boolean))
          // this.selectedTblData = response.data.data.map(e =>
          //   e.isAssigned === true && e.id
          // ).filter(Boolean)

          setTimeout(() => {
            $("#customerListTBL").DataTable({
              lengthMenu: [
                [10, 25, 50, -1],
                [10, 25, 50, "All"],
              ],
              pageLength: 10,
              info: false,
              targets: "no-sort",
              bSort: false,
              order: [],
              bFilter: true,
              bInfo: false,
              //   bLengthChange: false,
              bDestroy: true,
            });
          });
          // console.log(response.data.data);
          if (response.data.data.length === 0) {
            this.$moshaToast("No data available", {
              type: "danger",
              position: "top-right",
              showIcon: true,
            });
          }
        },
        (err) => {
          if (err.response.data.success === false) {
            this.customerServiceList = [];
          }
        }
      );
    },
    // delete
    deleteType(id) {
      if (id) {
        customerAPI.deleteCustomer(id).then(
          (response) => {
            this.$moshaToast(response.data.message, {
              type: "success",
              position: "top-right",
              showIcon: true,
            });
            // get all connection type
            customerAPI.getList().then((response) => {
              this.customerList = response.data.data;
            });
          },
          (err) => {
            this.$moshaToast(err.response.data.message, {
              type: "danger",
              position: "top-right",
              showIcon: true,
            });
          }
        );
      } else {
        this.$moshaToast("Please select service type", {
          type: "danger",
          position: "top-right",
          showIcon: true,
        });
      }
    },

    // change status
    changeStatus(id) {
      if (id) {
        customerAPI.changeStatus(id).then(
          (response) => {
            this.$moshaToast(response.data.message, {
              type: "success",
              position: "top-right",
              showIcon: true,
            });
            // get all connection type
            customerAPI.getList().then((response) => {
              this.customerList = response.data.data;
            });
          },
          (err) => {
            this.$moshaToast(err.response.data.message, {
              type: "danger",
              position: "top-right",
              showIcon: true,
            });
          }
        );
      } else {
        this.$moshaToast("Please select connection type", {
          type: "danger",
          position: "top-right",
          showIcon: true,
        });
      }
    },
  },
  mounted() {
    var url = location.href;
    var id = Number(url.substring(url.lastIndexOf('/') + 1));
    this.selectedCustomer = id
    if (id) {
      this.getServiceList(id)
    }
    //   list
    // customerAPI.getList().then(
    //   (response) => {
    //     this.customerList = response.data.data;

    //     // setTimeout(() => {
    //     //   $("#customerListTBL").DataTable({
    //     //     lengthMenu: [
    //     //       [10, 25, 50, -1],
    //     //       [10, 25, 50, "All"],
    //     //     ],
    //     //     pageLength: 10,
    //     //     info: false,
    //     //     targets: "no-sort",
    //     //     bSort: false,
    //     //     order: [],
    //     //     bFilter: true,
    //     //     bInfo: false,
    //     //     //   bLengthChange: false,
    //     //     bDestroy: true,
    //     //   });
    //     // });
    //   },
    //   (err) => {
    //     this.$moshaToast(err.response.data.message, {
    //       type: "danger",
    //       position: "top-right",
    //       showIcon: true,
    //     });
    //   }
    // );

    // if (this.selectedCustomer) {
    //   this.getServiceList();
    // }
  },
};
</script>

<style scoped>
thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: #dbd4d4;
  border-style: solid;
  border-width: 1px;
  padding: 10px 5px;
}

.btn {
  margin: 5px;
}

th {
  text-align: center !important;
}

.card {
  border-radius: 1.5em;
  border: 1px solid white;
}

.card-header:first-child {
  border-radius: 1.5em;
}

.modal-backdrop.fade.show {
  opacity: 1 !important;
  display: none;
}
</style>
